export default {
  en: {
    SYSTEM: {
      SITENAME: 'サイト名'
    },
    Home: {
      title: '俺のページ'
    },
    LABEL: {
      email: 'メールアドレス',
      password: 'パスワード'
    },
    MESSAGE: {
      required: '入力必須です'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/lang/lang_EN.js